import { createContext, useContext, useEffect, useMemo, useState } from 'react';

import DashboardIcon from '@app/components/icons/DashboardIcon';
import DiscoverIcon from '@app/components/icons/DiscoverIcon';
import HelpIcon from '@app/components/icons/HelpIcon';
import InboxIcon from '@app/components/icons/InboxIcon';
import ListingIcon from '@app/components/icons/ListingIcon';
import SettingsIcon from '@app/components/icons/SettingsIcon';

import { NavigationItem } from './useCommonData';

interface DashboardContextValue {
  sidebar?: NavigationItem[];
  collapseSidebar: boolean;
  setCollapseSidebar: any;
}

const DashboardContext = createContext<DashboardContextValue | undefined>(undefined);

export const DashboardProvider = ({ children }: { children: React.ReactNode }) => {
  const [sidebar, _setSidebar] = useState<NavigationItem[]>([
    { label: 'Tổng quan', href: '/dashboard', icon: <DashboardIcon size={24} /> },
    // { label: 'Hộp thư', href: '/dashboard/inbox', icon: <InboxIcon size={24} /> },
    {
      label: 'Quản lý giao dịch',
      href: '/dashboard/transactions',
      icon: <DiscoverIcon size={24} />,
    },
    { label: 'Quản lý bài đăng', href: '/dashboard/listing', icon: <ListingIcon size={24} /> },
    { label: 'Quản lý tài khoản', href: '/dashboard/profile', icon: <SettingsIcon size={24} /> },
  ]);
  const [collapseSidebar, setCollapseSidebar] = useState<boolean>(false);

  const value = useMemo<DashboardContextValue>(
    () => ({
      sidebar,
      collapseSidebar,
      setCollapseSidebar,
    }),
    [sidebar, collapseSidebar, setCollapseSidebar]
  );

  useEffect(() => {
    const collapseSidebar = localStorage.getItem('collapseSidebar');
    if (collapseSidebar) {
      setCollapseSidebar(collapseSidebar === 'true');
    }
  }, []);

  return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>;
};

export const useDashboard = (): DashboardContextValue => {
  const context = useContext(DashboardContext);

  if (!context) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }

  return context;
};
